import * as ActionTypes from '../constants/actions';
import _ from 'lodash';



export function setActiveRoom(activeRoom) {
	return {
		type : ActionTypes.ROOM.SET_ACTIVE_ROOM_DATA,
        activeRoom
	};
}

export function unsetActiveRoom() {
	return {
		type : ActionTypes.ROOM.UNSET_ACTIVE_ROOM_DATA
	};
}
